module.exports = __webpack_public_path__ + "img/phone.1c15cc72.webp";